import { call, cancelled, put, take, takeLatest, cancel } from 'redux-saga/effects';
import log from "loglevel";

const authenticateFromAPi = (login = "", password = "") => {
	return new Promise((resolve, reject) => {
		if (password === "qwerty") {
			return resolve({
				userLogin: login,
				jwtToken: "error",
				permissions: ["NPFornec_Renner_Admin"],
			})
		} else {
			return reject({
				message : "AUTHENTICATION FAILED"
			})
		}
	})
	// return new Promise((resolve, reject) => {
	// 	return axios(getEnvParam("REACT_APP_URL_LOGIN"),
	// 		{
	// 			method: "GET",
	// 			headers: {
	// 				'Content-Type': 'application/json',
	// 				'NPF_ROUTE': getEnvParam("REACT_APP_HEADER_LOGIN"),
	// 			},
	// 			data: { uid: login, password: password }
	// 		})
	// 		.then(response => response.status !== 200 ? reject(response) : response)
	// 		.then(response => {
	// 			return {
	// 				jwtToken: "Bear pouahsoauhsaapuahspaoush",
	// 				permissions: ["mdl-lista-po", "mdl-carga", "mdl-conciliacao", "mdl-relatorio-po", "mdl-agendamento", "mdl-upload"],
	// 				...response.data,
	// 			}
	// 		})
	// 		.then(response => resolve(response))
	// 		.catch(error => {
	// 			reject(error);
	// 			log.info(error);
	// 		});
	// }); 
};

export function* authenticate(login, password) {
	try {
		const data = yield call(authenticateFromAPi, login, password)
		const { jwtToken, permissions, message, userLogin } = data

		if (message === "AUTHENTICATION FAILED") {
			localStorage.clear();
			yield put({ type: 'LOGIN_UNAUTHORIZED' })

			yield put({ type: 'CLEAN_AUTHORIZATION' })

		} else if (jwtToken !== undefined && jwtToken !== null) {
			yield put({
				type: 'AUTHORIZATION',
				permissions: permissions
			})

			yield put({
				type: 'SAVE_LOGIN',
				login: userLogin ? userLogin : login
			})

			yield put({
				type: 'LOGIN_SUCCESS',
				token: "Bearer " + jwtToken
			})


		} else {
			yield put({ type: 'LOGIN_ERROR' })
		}

	} catch (error) {
		localStorage.clear();
		yield put({ type: 'LOGIN_UNAUTHORIZED' })

		yield put({ type: 'CLEAN_AUTHORIZATION' })

		yield put({ type: 'LOGIN_ERROR', error })
	}
	finally {
		if (yield cancelled()) {
			yield put({ type: 'LOGIN_CANCELLED' })
		}
	}
}

export function* loginFlow(payload) {
	try {
		const task = yield call(authenticate, payload.login, payload.password);
		const action = yield take(['LOGOUT', 'LOGIN_ERROR'])
		if (action.type === 'LOGOUT') {
			localStorage.clear();
			yield cancel(task)
			yield put({ type: 'DELETE_LOGIN' })
		}
	} catch (error) {
		log.info(error);
	}

}

export function* logout(payload) {
	try {
		yield put({ type: 'LOGOUT' })
		yield put({ type: 'CLEAN_AUTHORIZATION' })
		localStorage.clear();
	} catch (error) {
		log.info(error);
	}
}

export function* authenticationWatcher() {
	yield takeLatest("LOGIN_REQUEST", loginFlow);
	yield takeLatest("LOGOUT_REQUEST", logout);
}
